import slugify from "slugify";

const slugifyOptions = { remove: /[*+~.,()|'"!:@]/g }
const companyLink = (company) =>
  `/companies/${slugify(company, slugifyOptions)}`

const jobLink = (company, title, id) =>
  `/featured-jobs/${slugify(company, slugifyOptions)}-${slugify(title, slugifyOptions)}-${id}`

export {companyLink, jobLink};